import request from './request';

export function getSongDetail(ids) {
    return request({
        url: "",
        params: {
            ids
        }
    })
}

export function getLyric(id) {
    return request({
        url: "/lyric",
        params: {
            id
        }
    })
}

export function getSimiPlaylist(id) {
    return request({
        url: "/simi/playlist",
        params: {
            id
        }
    })
}

export function getSimiSong(id) {
    return request({
        url: "/simi/song",
        params: {
            id
        }
    })
}
